import * as React from 'react';
import styled from 'styled-components';
import { IBaseComponentProps } from '../../types';
import { INotificationInfo } from '../notification-types';
import { NotificationItemMessage } from './notification-item-message';

type IRenderFunction = () => React.ReactNode;

interface INotificationItemContentProps extends Pick<INotificationInfo, 'type' | 'message' | 'additionalInfo'>, IBaseComponentProps {
    isActionButtonVisible?: boolean;
    getOnRenderNotificationIcon(): IRenderFunction | undefined;
}

const ContentWrapper = styled.div.attrs(() => ({
    className: String('ap-notification-contentWrapper')
})) <{ $isActionButtonVisible?: boolean; }>`
    padding: ${({ theme: { semantics: { gap } } }) => `${gap.l} ${gap.xxl}`};
    width: ${({ $isActionButtonVisible }) => ($isActionButtonVisible ? 'calc(100% - 185px)' : 'unset')};
`;

export function NotificationItemContent(props: INotificationItemContentProps) {
    const { getOnRenderNotificationIcon, additionalInfo, isActionButtonVisible, message, type } = props;
    const renderIcon = getOnRenderNotificationIcon();
    return (
        <ContentWrapper $isActionButtonVisible={isActionButtonVisible}>
            {renderIcon && renderIcon()}
            <NotificationItemMessage type={type} additionalInfo={additionalInfo} message={message} />
        </ContentWrapper>
    );
}
